// extracted by mini-css-extract-plugin
export default {"grid":"EntityTable_grid__-yZTC"};